import './style-header-overlap.scss';
document.addEventListener('DOMContentLoaded', function () {

    // 「ヘッダーに重ねる」が有効で、実際に表示されているものを1つだけ取る
    function getVisibleOverlapMv() {
        var list = document.querySelectorAll('.lpc-blocks-main-visual-v2-header-overlap');
        for (var i = 0; i < list.length; i++) {
            var el = list[i];
            // 各デバイス用ブロックのラッパを取得する
            var wrapper = el.closest('.wp-block-lpc-blocks-main-visual-v2');
            if (!wrapper) continue;

            // wrapperが非表示(display:noneなど)なら getClientRects() は 0
            if (wrapper.getClientRects().length === 0) continue;
            var wst = window.getComputedStyle(wrapper);
            if (wst.visibility === 'hidden' || wst.display === 'none') continue;

            // el自身も可視チェック
            if (el.getClientRects().length === 0) continue;
            var est = window.getComputedStyle(el);
            if (est.visibility === 'hidden' || est.display === 'none') continue;

            // ここまで来たら実際に画面に描画されている
            return el;
        }
        return null;
    }

    // 重ねる対象のMVを取得
    var overlapMv = getVisibleOverlapMv();

    // headerを取得
    var header = document.getElementById('header');
    if (!header) return;

    // カスタマイザーで「スクロールに追従」がONかどうか
    var isFixedByCustomizer = header.classList.contains('l-header--fixed');

    // ヘッダー内のリンク
    var links = header.querySelectorAll('a');

    // rootから初期スタイルを取得する
    var rootStyle = window.getComputedStyle(document.documentElement);
    var initialBg = rootStyle.getPropertyValue('--lpc-header-bg-color') ? rootStyle.getPropertyValue('--lpc-header-bg-color').trim() : '#fff';
    var initialTextColor = rootStyle.getPropertyValue('--lpc-header-color') ? rootStyle.getPropertyValue('--lpc-header-color').trim() : '#333';
    var initialShadow = header.classList.contains('l-header--shadow') ? '0 0 8px rgba(0,0,0,.16)' : 'none';

    // ヘッダーの高さ（相殺用）
    var headerHeight = header.offsetHeight;

    // 重ねる時に使う色を取得
    function getOverlapTextColor(el) {
        if (!el || !el.dataset || !el.dataset.lpcbHeaderLinkColor) {
            return '#fff';
        }
        return el.dataset.lpcbHeaderLinkColor.trim();
    }

    // MVの下端のスクロール位置（ここを超えたら「重ねる」をやめる）
    function getOverlapBottom() {
        // 重ねるMVが無ければ0（常に通常モードへ）
        if (!overlapMv) {
            return 0;
        }
        // MVのビュー位置
        var rect = overlapMv.getBoundingClientRect();
        // 現在スクロール量
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return rect.top + scrollTop + 1;
    }

    // 重ねているときの見た目
    function applyOverlap() {
        header.classList.add('lpcb-header-overlap'); // cssのスタイル追加
        header.style.position = 'absolute';
        header.style.top = '0';
        header.style.left = '0';
        header.style.width = '100%';
        header.style.background = 'rgba(255,255,255,0)';
        header.style.boxShadow = 'none';
        // MVはヘッダーぶんを引かない
        if (overlapMv) overlapMv.style.marginTop = '0';
        // リンクを重ね色の設定に変更
        for (var i = 0; i < links.length; i++) {
            links[i].style.color = getOverlapTextColor(overlapMv);
        }
    }

    // 固定表示（カスタマイザーで追従がONのときだけ使う）
    function applyFixed() {
        header.classList.remove('lpcb-header-overlap');
        header.style.position = 'fixed';
        header.style.top = '0';
        header.style.left = '0';
        header.style.width = '100%';
        header.style.background = initialBg;
        header.style.boxShadow = initialShadow;
        // 固定のときはMV側はいじらない
        if (overlapMv) overlapMv.style.marginTop = '0';
        for (var i = 0; i < links.length; i++) {
            links[i].style.color = initialTextColor;
        }
    }

    // 通常スクロール（カスタマイザー追従がOFFで、MVを抜けたあと）
    function applyStatic() {
        header.classList.remove('lpcb-header-overlap');
        header.style.position = 'static';
        header.style.background = initialBg;
        header.style.boxShadow = initialShadow;
        // ヘッダーがレイアウトに入るぶんをMVで打ち消す
        if (overlapMv) overlapMv.style.marginTop = '-' + headerHeight + 'px';
        for (var i = 0; i < links.length; i++) {
            links[i].style.color = initialTextColor;
        }
    }

    // 抑止ロジック（同じモード再適用を避ける）
    var currentMode = null; // 'overlap' | 'fixed' | 'static'
    function setMode(mode) {
        // 変化なしなら何もしない（不要なstyle再適用・reflow/repaintを抑止）
        if (mode === currentMode) return;
        currentMode = mode;

        if (mode === 'overlap') {
            applyOverlap();
        } else if (mode === 'fixed') {
            applyFixed();
        } else {
            applyStatic(); // 'static'
        }
    }

    // スクロールに応じて切り替える
    function handleScroll() {
        // 現在のスクロール位置
        var sc = window.pageYOffset || document.documentElement.scrollTop;

        // 次に適用すべきモードを決める
        var nextMode;
        // 可視MVが無い：端末切替でSPだけ「重ねOFF」のとき等
        if (!overlapMv) {
            nextMode = isFixedByCustomizer ? 'fixed' : 'static';
        } else if (isFixedByCustomizer) {
            // カスタマイザーで「追従する」＝ON
            nextMode = (sc < 100) ? 'overlap' : 'fixed';
        } else {
            // カスタマイザーで「追従する」＝OFF
            var overlapBottom = getOverlapBottom(); // リサイズ後、毎回最新で判定
            nextMode = (sc < overlapBottom) ? 'overlap' : 'static';
        }
        setMode(nextMode); // ここで実適用（同モードなら何もしない）
    }

    // 初期反映(ページ読込時点)
    handleScroll();

    // スクロールで判定（同モードなら適用スキップされる）
    window.addEventListener('scroll', handleScroll, { passive: true });

    // リサイズ処理
    var resizeTimer = null; // 連続リサイズ防止タイマー
    function handleResize() {
        // 既存タイマーのクリア
        if (resizeTimer) clearTimeout(resizeTimer);
        // 120ms待ってから反映させる(連続リサイズ防止)
        resizeTimer = setTimeout(function () {
            // レイアウト確定用（2段階 rAF）
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    overlapMv = getVisibleOverlapMv();  // 端末幅に対応した“今見えてる”MVを取り直す
                    headerHeight = header.offsetHeight; // ヘッダー高さも取り直す
                    handleScroll();                     // 反映（setMode経由で抑止）
                });
            });
        }, 120);
    }
    // リスナー登録
    window.addEventListener('resize', handleResize, { passive: true }); // 画面リサイズ
    window.addEventListener('orientationchange', handleResize);         // 端末の向き
});
